import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  slug: string;
  thumbnail: string;
  category: string;
  categoryName: string;
  views: number;
  date: string;
  duration: string;
  isHot?: boolean;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function VideoCard({
  id,
  title,
  slug,
  thumbnail,
  categoryName,
  views,
  date,
  duration,
  isHot,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
    >
      {/* Thumbnail */}
      <div className="relative w-full aspect-video overflow-hidden">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={title}
        />
        {/* Duration Badge */}
        <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium bg-black/70 text-white rounded-md">
          {duration}
        </span>
        {/* Hot Badge */}
        {isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-bold bg-primary-500 text-background-50 rounded-md flex items-center gap-1">
            <i className="ri-fire-line"></i>
            热门
          </span>
        )}
        {/* Play Overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center justify-between mt-2.5">
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-md font-medium">
            {categoryName}
          </span>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {formatViews(views)}
            </span>
            <span>{date}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}